import React from 'react';
import './HeroSection.css';

const HeroSection = ({ onEnrollClick }) => {
  return (
    <section className="ucp-section ucp-hero">
      <div className="hero-container">
        <div className="hero-left">
          <div className="starting-badge">
            <span className="badge-start">STARTING</span>
            <span className="badge-date">JULY 2026</span>
          </div>

          <h1 className="main-title">
            PREMIUM <br />
            <span className="blue-text">JAVA 2026</span>
          </h1>

          <div className="batch-pill-tilted">
            45-DAYS OFFLINE BATCH
          </div>

          <div className="hero-announcement-box">
            <div className="announcement-item">
              <span className="live-pulse-dot"></span>
              <span className="announcement-icon">
                <svg className="announcement-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </span>
              <span className="announcement-text">
                Free Lecture on <strong>5 & 6 September</strong>
              </span>
            </div>
            <div className="announcement-divider"></div>
            <div className="announcement-item">
              <span className="announcement-icon">
                <svg className="announcement-svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </span>
              <span className="announcement-text">
                Duration: <strong>5 Months (Ends January)</strong>
              </span>
            </div>
          </div>

          <p className="hero-desc">
            From <strong>Fundamentals</strong> to <strong>Industry-Ready</strong> Java Developer. Master the enterprise ecosystem in an intensive, hands-on environment.
          </p>

          <div className="icon-grid">
            <div className="icon-item">
              <div className="icon-box">
                <img src="/assets/images/upcomingCourse/traing_logo.png" alt="Training" className="grid-3d-icon" />
              </div>
              <span>COMPLETE TRAINING</span>
            </div>
            <div className="icon-item">
              <div className="icon-box">
                <img src="/assets/images/upcomingCourse/real_time_project.png" alt="Project" className="grid-3d-icon" />
              </div>
              <span>REAL-TIME PROJECT</span>
            </div>
            <div className="icon-item">
              <div className="icon-box">
                <img src="/assets/images/upcomingCourse/500_questions.png" alt="Questions" className="grid-3d-icon" />
              </div>
              <span>APTITUDE 34 TOPICS</span>
            </div>
            <div className="icon-item">
              <div className="icon-box">
                <img src="/assets/images/upcomingCourse/super_cer.png" alt="Certificate" className="grid-3d-icon" />
              </div>
              <span>SUPERX CERTIFICATE</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="video-visual-container">
            <div className="hero-video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/QRrI-5vu-lQ?autoplay=1&mute=1"
                title="Announcement Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <button className="btn-explore-right" onClick={onEnrollClick}>
            ADMISSION OPEN <span>→</span>
          </button>
        </div>
      </div>

      <div className="highlights-bar">
        <div className="h-bar-item">
          <img src="/assets/images/upcomingCourse/roadmap.png" alt="Roadmap" className="h-3d-icon" />
          <div className="h-bar-text">
            <strong>200 Practical Questions</strong>
            <p>LIVE | DAILY 3:00 PM – 4:30 PM</p>
          </div>
        </div>
        <div className="h-bar-divider"></div>
        <div className="h-bar-item">
          <img src="/assets/images/upcomingCourse/winner-removebg-preview.png" alt="Winner" className="h-3d-icon" />
          <div className="h-bar-text">
            <strong>1000+ Quiz Practice Questions</strong>
            <p>+ QUIZEETHON COMPETITION</p>
          </div>
        </div>
        <div className="h-bar-divider"></div>
        <div className="h-bar-item">
          <img src="/assets/images/upcomingCourse/500_questions.png" alt="Logic Questions" className="h-3d-icon" />
          <div className="h-bar-text">
            <strong>500+ Logic Building Questions</strong>
            <p>WITH VIDEO EXPLANATIONS</p>
          </div>
        </div>
        <div className="h-bar-divider"></div>
        <div className="h-bar-item">
          <img src="/assets/images/upcomingCourse/interview.png" alt="Interview" className="h-3d-icon" />
          <div className="h-bar-text">
            <strong>100 Interview Questions</strong>
            <p>WITH VIDEO EXPLANATIONS</p>
          </div>
        </div>
        <div className="h-bar-divider"></div>
        <div className="h-bar-item fees-item">
          <div className="h-bar-text">
            <strong>₹10,000</strong>
            <p>+ 18% GST</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
